import {GetStaticProps} from "next";
import {MarkdownMetaDataInterface} from "../../interfaces/MarkdownMetaDataInterface";
import SimpleMarkdownPageWithHeader from "../../components/common/SimpleMarkdownPageWithHeader";
import {getStaticPropsForMarkdownPage} from "../../helpers/GetStaticPropsForMarkdownPage";
import ContactUsPanel from "../../components/ContactUsPanel/ContactUsPanel";
import {getSafeLocale} from "../../helpers/LocalizeObject";

function Page({
	              result,
	              markdown: MDXFile,
              }: {
	result: MarkdownMetaDataInterface;
	markdown: any;
}) {
	return (
		<>
			<SimpleMarkdownPageWithHeader mdxFile={MDXFile} metadata={result}/>
			<ContactUsPanel/>
		</>
	);
}

export const getStaticProps: GetStaticProps = async (context) => {
	return getStaticPropsForMarkdownPage(getSafeLocale(context.locale)!, "eigentuemer");
};

export default Page;
